import { ReactNode } from 'react';
import { Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';

import { cx } from '@libs/classnames';

import styles from './LinearChart.module.css';

type ChartPoint = {
  x: number;
  y: number;
  label?: ReactNode;
};

type CustomTickProps = {
  x: number;
  y: number;
  payload: {
    value: number;
  };
};

// TODO refactor
const CustomTick = ({ x, y, payload }: CustomTickProps) => {
  const isWin = payload.value > 0;
  const isLoss = payload.value < 0;
  const isDraw = payload.value === 0;

  if (payload.value === null) return <></>;
  return (
    <g transform={`translate(${x},${y - 24})`}>
      <text
        className={cx(styles.tick, {
          [styles.win]: isWin,
          [styles.loss]: isLoss,
          [styles.draw]: isDraw,
        })}
        x={0}
        y={0}
        dy={16}
        textAnchor="start"
        fill="#666"
        transform="translate(2, -4)"
      >
        {isWin ? `+${payload.value}` : payload.value}
      </text>
      <line x1={0} x2={0} y1={0} y2={58} stroke="url(#fadeGradient)" strokeWidth={1}></line>
    </g>
  );
};

export type Props = {
  className?: string;
  points: ChartPoint[];
  showTicks?: boolean;
};
export function LinearChart({ className, points, showTicks }: Props) {
  return (
    <div className={cx(styles.chartsContainer, className)}>
      <ResponsiveContainer width="100%">
        <LineChart className={styles.chart} data={points} dataKey="y">
          <defs>
            <linearGradient
              id="goldenGradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0%" stopColor="#B87107" stopOpacity={0.15} />
              <stop offset="100%" stopColor="#CE9744" stopOpacity={1} />
            </linearGradient>
            <linearGradient
              id="fadeGradient"
              x1="0%"
              y1="0%"
              x2="0%"
              y2="100%"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0%" stopColor="#FFFFFF" stopOpacity={0.1} />
              <stop offset="50%" stopColor="#FFFFFF" stopOpacity={0.1} />
              <stop offset="100%" stopColor="#FFFFFF" stopOpacity={0.01} />
            </linearGradient>
          </defs>

          {showTicks && (
            <XAxis
              dataKey="label"
              tick={CustomTick}
              orientation="top"
              tickLine={false}
              axisLine={false}
              interval="preserveStart"
            />
          )}

          <YAxis domain={[Math.min(...points.map((p) => p.y)), 'auto']} hide />

          <Line
            type="linear"
            dataKey="y"
            stroke="url(#goldenGradient)"
            strokeWidth={2}
            dot={false}
            activeDot={false}
            animationDuration={300}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
